import React  from 'react';
import styled from 'styled-components';
import { TextBtn } from '../Inputs/TextBtn';
import { TextBtn2 } from '../Inputs/TextBtn2';
import { formatPrice } from '../Functions/Price';
const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 1rem var(--universal-pad) 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1rem;
  .top {
    display: flex;
    padding: 1rem 1.5rem;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--n-grey-0);
    background-color: #036663;
    color: var(--n-grey-0);
    border-radius: var(--border-radius-3);
    .image {
      svg {
        display: block;
      }
    }
    .title {
      font-size: 2rem;
      font-weight: 600;
    }
    .btn {
      flex-grow: 1;
      max-width: 200px;
    }
  }
  .box {
    display: flex;
    gap: 1rem;
    .item {
      padding: 1rem;
      flex-grow: 1;
      background-color: var(--n-grey-0);
      border: 1px solid var(--n-grey-2);
      border-radius: var(--border-radius-3);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title {
        margin: 1rem 0;
        text-align: center;
        font-size: 1.5rem;
        font-weight: 600;
      }
      .line-v {
        height: 1px;
        background-color: var(--n-grey-1);
      }
      .data {
        margin: 0.5rem 0;
        display: flex;
        flex-direction: column;
        .value {
          padding: 0.7rem 0;
          display: flex;
          gap: 0.5rem;
          border-bottom: 1px solid var(--n-grey-1);
          &:first-child {
            border-top: 1px solid var(--n-grey-1);
          }
        }
      }
      .price {
        margin: 0 0 1rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 0.5rem;
        align-self: center;
        flex-grow: 1;
        &.main {
          margin: 1rem 0 0;
          position: relative;
          &::after {
            content: "";
            z-index: 1;
            position: absolute;
            top: 50%;
            width: 110%;
            height: 2px;
            border-radius: 10px;
            background-color: red;
          }
        }
        .value {
          font-size: 1.5rem;
          font-weight: 600;
        }
        .curr {
          font-size: 1.2rem;
          font-weight: 600;
        }
      }
    }
  }
  @media screen and (max-width:850px) {
    .top {
      padding: 0 1rem 1rem;
      flex-direction: column;
      gap: 1rem;
      .title {
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }
      .btn {
        align-self: normal;
        max-width: none;
      }
    }
    .box {
      flex-direction: column;
    }
  }
  
`
export default function Pricing34 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const buy = () => {
    window.alert("no connection to payment system")
  }
  // console.log('aasssdddd')
  // console.log('<<<<<<' + data)
  const makeItems = () => {
    return items.map((v, i) => {
      return (
        <div className='item' key={i}>
          <div className='title'>
            {v.title}
          </div>
          <div className='data'>
            {
              v.values.map((vv, ii) => {
                return (
                  <div className='value' key={ii}>
                    <div className='icon'>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="6.07129" y="-1" width="10" height="10" rx="3" transform="rotate(45 6.07129 -1)" fill="#036663"/>
                      </svg>
                    </div>
                    <div className='text'>
                      {vv}
                    </div>
                  </div>
                )
              })
            }
          </div>
          {
            (v.mainPrice > v.price) ? (
              <>
                <div className='price main'>
                  <div className='value'>
                    {formatPrice(v.mainPrice)}
                  </div>
                  <div className='curr'>
                    تومان
                  </div>
                </div>
                <div className='price'>
                  <div className='value'>
                    {formatPrice(v.price)}
                  </div>
                  <div className='curr'>
                    تومان
                  </div>
                </div>
              </>
            ) : (
              <div className='price'>
                <div className='value'>
                  {formatPrice(v.price)}
                </div>
                <div className='curr'>
                  تومان
                </div>
              </div>
            )
          }
          
          <div className='line-v'></div>
          <div className='btn'>
            از طریق قسمت تنظیمات پنل آژانس خرید کنید
            {/* <TextBtn2
              newType={2}
              text={"خرید اشتراک"}
              onclick={buy}
            /> */}
          </div>
        </div>
      )
    })
    
  }
  return (
    <Styles>
      <div className='box'>
        {makeItems()}
      </div>
    </Styles>
  )
}


const items = [
  {
    id: 0,
    title: "اشتراک یک ماهه",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "خدمات آموزشی ",
    ],
    mainPrice: 9500000,
    price: 9500000
  },
  {
    id: 0,
    title: "اشتراک سه ماهه",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "خدمات آموزشی ",
    ],
    mainPrice: 28500000,
    price: 27000000
  },
  {
    id: 1,
    title: "اشتراک شش ماهه",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "یک آگهی رایگان یک ماهه",
    ],
    mainPrice: 57000000,
    price: 53000000,
  },
  {
    id: 2,
    title: "اشتراک یک ساله",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "سه آگهی رایگان یک ماهه",
    ],
    mainPrice: 114000000,
    price: 102000000
  }
]
